"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleController = void 0;
/**
 * 나중에 한 번 실행할 작업을 예약하는 ReactiveController.
 *
 * 요청이 겹치면 마지막 요청만 실행하므로, 렌더·리사이즈마다 쏟아지는 요청을 한 번의 측정이나
 * 스타일 쓰기로 합치고(다음 프레임), 입력이 멈출 때까지 기다리는 debounce나 자동 닫힘 같은
 * 시간 지연도 같은 규칙으로 다룬다(delay). host가 분리되면 예약을 취소해 분리된 뒤에 작업이 돌지 않는다.
 */
class ScheduleController {
    constructor(host, callback, options = {}) {
        this.callback = callback;
        this.options = options;
        this.handle = 0;
        host.addController(this);
    }
    /** 이전 예약을 취소하고 다시 예약한다. */
    request() {
        this.cancel();
        const run = () => {
            this.handle = 0;
            this.callback();
        };
        if (this.options.delay === undefined) {
            this.handle = requestAnimationFrame(run);
            return;
        }
        this.handle = window.setTimeout(run, this.options.delay);
    }
    /** 예약된 작업이 없어도 안전하게 부를 수 있다. */
    cancel() {
        if (!this.handle)
            return;
        if (this.options.delay === undefined)
            cancelAnimationFrame(this.handle);
        else
            window.clearTimeout(this.handle);
        this.handle = 0;
    }
    hostDisconnected() {
        this.cancel();
    }
}
exports.ScheduleController = ScheduleController;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2NoZWR1bGUtY29udHJvbGxlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInNjaGVkdWxlLWNvbnRyb2xsZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBT0E7Ozs7OztHQU1HO0FBQ0gsTUFBYSxrQkFBa0I7SUFHN0IsWUFDRSxJQUE0QixFQUNwQixRQUFvQixFQUNwQixVQUEyQixFQUFFO1FBRDdCLGFBQVEsR0FBUixRQUFRLENBQVk7UUFDcEIsWUFBTyxHQUFQLE9BQU8sQ0FBc0I7UUFML0IsV0FBTSxHQUFHLENBQUMsQ0FBQTtRQU9oQixJQUFJLENBQUMsYUFBYSxDQUFDLElBQUksQ0FBQyxDQUFBO0lBQzFCLENBQUM7SUFFRCwyQkFBMkI7SUFDM0IsT0FBTztRQUNMLElBQUksQ0FBQyxNQUFNLEVBQUUsQ0FBQTtRQUViLE1BQU0sR0FBRyxHQUFHLEdBQUcsRUFBRTtZQUNmLElBQUksQ0FBQyxNQUFNLEdBQUcsQ0FBQyxDQUFBO1lBQ2YsSUFBSSxDQUFDLFFBQVEsRUFBRSxDQUFBO1FBQ2pCLENBQUMsQ0FBQTtRQUNELElBQUksSUFBSSxDQUFDLE9BQU8sQ0FBQyxLQUFLLEtBQUssU0FBUyxFQUFFO1lBQ3BDLElBQUksQ0FBQyxNQUFNLEdBQUcscUJBQXFCLENBQUMsR0FBRyxDQUFDLENBQUE7WUFDeEMsT0FBTTtTQUNQO1FBRUQsSUFBSSxDQUFDLE1BQU0sR0FBRyxNQUFNLENBQUMsVUFBVSxDQUFDLEdBQUcsRUFBRSxJQUFJLENBQUMsT0FBTyxDQUFDLEtBQUssQ0FBQyxDQUFBO0lBQzFELENBQUM7SUFFRCxnQ0FBZ0M7SUFDaEMsTUFBTTtRQUNKLElBQUksQ0FBQyxJQUFJLENBQUMsTUFBTTtZQUFFLE9BQU07UUFFeEIsSUFBSSxJQUFJLENBQUMsT0FBTyxDQUFDLEtBQUssS0FBSyxTQUFTO1lBQUUsb0JBQW9CLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxDQUFBOztZQUNsRSxNQUFNLENBQUMsWUFBWSxDQUFDLElBQUksQ0FBQyxNQUFNLENBQUMsQ0FBQTtRQUNyQyxJQUFJLENBQUMsTUFBTSxHQUFHLENBQUMsQ0FBQTtJQUNqQixDQUFDO0lBRUQsZ0JBQWdCO1FBQ2QsSUFBSSxDQUFDLE1BQU0sRUFBRSxDQUFBO0lBQ2YsQ0FBQztDQUNGO0FBdkNELGdEQXVDQyJ9